import ModalFullHeightRight from "@/components/modals/ModalFullHeightRight.vue";
import HeaderProfitabilityAnalysis from "@/components/financialReports/profitabilityAnalysis/HeaderProfitabilityAnalysis.vue";
import BodyProfitabilityAnalysis from "@/components/financialReports/profitabilityAnalysis/BodyProfitabilityAnalysis.vue";

// Config estática del drawer "Análisis de Categorías" que abre RentabilidadTab
// con `$buefy.modal.open`. Sin `parent` ni `events`: dependen de la instancia
// (el modal se parenta a la vista y los listeners apuntan a sus métodos), así
// que la vista los agrega al hacer spread. Mismo reparto que
// `salesDrawerModals`, testeable como función pura.
const PROFITABILITY_THEME = "rentabilidad";

// Header y cuerpo leen el store: los filtros (granularidad, rango y
// categorías) viven en el cuerpo y comparten el estado del tab.
export function profitabilityAnalysisModalConfig() {
	return {
		hasModalCard: true,
		customClass: "wide-summary-modal",
		canCancel: ["escape", "outside"],
		component: ModalFullHeightRight,
		props: {
			headerComp: HeaderProfitabilityAnalysis,
			bodyComp: BodyProfitabilityAnalysis,
			headerProps: null,
			bodyProps: null,
			theme: PROFITABILITY_THEME,
			// Mismo ancho que el análisis de Ventas/Costos: 85 % con tope en
			// 1300px para que las cards no se estiren en monitores anchos.
			width: "min(85%, 1300px)",
		},
	};
}
